<div class="ig-carousel" *ngIf="images && images.length > 0">
  <div class="ig-viewport" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
    <div class="ig-track" [style.transform]="'translateX(-' + (currentIndex * (100 / count)) + '%)'">
      <div class="ig-slide" *ngFor="let img of images; let i = index; trackBy: trackByIndex"
           [style.flex-basis]="slideWidth">
        <button type="button" class="ig-photo" (click)="openPopup(i, $event)"
                [attr.aria-label]="'Ampliar fotografía ' + (i + 1) + ' de ' + images.length">
          <img [src]="img.thumb || img.full" [alt]="titulo || 'Fotografía ' + (i + 1)"
               [attr.loading]="i < count ? 'eager' : 'lazy'" decoding="async" />
          <span class="ig-zoom" aria-hidden="true"><i class="fa-solid fa-expand"></i></span>
        </button>
      </div>
    </div>
    <button *ngIf="canNavigate" class="ig-arrow ig-arrow-left" type="button"
            (click)="prev()" aria-label="Fotografía anterior">
      <i class="fa-solid fa-chevron-left"></i>
    </button>
    <button *ngIf="canNavigate" class="ig-arrow ig-arrow-right" type="button"
            (click)="next()" aria-label="Fotografía siguiente">
      <i class="fa-solid fa-chevron-right"></i>
    </button>
    <div class="ig-counter" *ngIf="images.length > 1">{{ currentIndex + 1 }} / {{ totalPages }}</div>
  </div>
  <div class="ig-dots" *ngIf="totalPages > 1" aria-label="Navegación del carrusel">
    <button *ngFor="let page of [].constructor(totalPages); let i = index"
            type="button" class="ig-dot" [class.active]="i === currentIndex"
            [attr.aria-label]="'Ir a la posición ' + (i + 1)" [attr.aria-current]="i === currentIndex ? 'true' : null"
            (click)="goTo(i)"></button>
  </div>
</div>

<div class="ig-lightbox" *ngIf="selectedImage as image" role="dialog" aria-modal="true"
     aria-label="Visor de fotografías" (click)="closePopup()"
     (touchstart)="onModalTouchStart($event)" (touchend)="onModalTouchEnd($event)">
  <div class="ig-lightbox-top" (click)="$event.stopPropagation()">
    <div class="ig-lightbox-title" *ngIf="titulo || texto1 || texto2">
      <strong *ngIf="titulo">{{ titulo }}</strong>
      <span *ngIf="texto1">{{ texto1 }}</span>
      <span *ngIf="texto2">{{ texto2 }}</span>
    </div>
    <span class="ig-lightbox-count">{{ (popupIndex || 0) + 1 }} / {{ images.length }}</span>
    <button class="ig-lightbox-close" type="button" (click)="closePopup()" aria-label="Cerrar fotografía">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <button *ngIf="images.length > 1" class="ig-lightbox-nav prev" type="button"
          (click)="$event.stopPropagation(); popupPrev()" aria-label="Fotografía anterior">
    <i class="fa-solid fa-chevron-left"></i>
  </button>
  <img class="ig-lightbox-image" [src]="image.full || image.thumb" [alt]="titulo || 'Fotografía ampliada'"
       (click)="$event.stopPropagation()" />
  <button *ngIf="images.length > 1" class="ig-lightbox-nav next" type="button"
          (click)="$event.stopPropagation(); popupNext()" aria-label="Fotografía siguiente">
    <i class="fa-solid fa-chevron-right"></i>
  </button>
  <div class="ig-lightbox-hint">Usa las flechas para navegar · Esc para cerrar</div>
</div>
